/* eslint-disable */
import {
	Geometry2d,
	RecordProps,
	Rectangle2d,
	ShapeUtil,
	SVGContainer,
	T,
	TLBaseShape,
	TLResizeInfo,
	resizeBox,
	TLDefaultColorStyle,
	DefaultColorStyle,
	getDefaultColorTheme,
} from "tldraw";
import { TLIconDefaultColor } from "@/helper";

type ICustomShape = TLBaseShape<
	"sound_element",
	{
		w: number;
		h: number;
		color: TLDefaultColorStyle;
	}
>;

// [2]
export class SoundElement extends ShapeUtil<ICustomShape> {
	static override type = "sound_element" as const;
	static override props: RecordProps<ICustomShape> = {
		w: T.number,
		h: T.number,
		color: DefaultColorStyle as any,
	};

	// [b]
	getDefaultProps(): ICustomShape["props"] {
		return {
			w: 33,
			h: 15,
			color: TLIconDefaultColor,
		};
	}

	// [c]
	override canEdit() {
		return true;
	}

	override canResize() {
		return true;
	}
	override isAspectRatioLocked() {
		return false;
	}

	// [d]
	getGeometry(shape: ICustomShape): Geometry2d {
		return new Rectangle2d({
			width: shape.props.w,
			height: shape.props.h,
			isFilled: true,
		});
	}

	// [e]
	override onResize(shape: ICustomShape, info: TLResizeInfo<any>) {
		return resizeBox(shape, info);
	}

	// [f]
	component(shape: ICustomShape) {
		const theme = getDefaultColorTheme({ isDarkMode: false });
		const themeColor = theme[shape.props.color] as { solid: string };
		const fill = themeColor.solid;

		return (
			<SVGContainer>
				<svg id="a" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
					<path
						d="M13,12H3c-1.65,0-3,1.35-3,3v30c0,1.65,1.35,3,3,3h12c.55,0,1-.45,1-1V15c0-1.65-1.35-3-3-3ZM8,18c2.21,0,4,1.79,4,4s-1.79,4-4,4-4-1.79-4-4,1.79-4,4-4ZM8.71,31.71c-.05.04-.1.08-.16.12-.05.04-.11.07-.17.09-.06.03-.12.05-.19.06-.06.01-.13.02-.19.02-.26,0-.52-.11-.71-.29-.18-.19-.29-.45-.29-.71s.11-.52.29-.71c.37-.37,1.05-.37,1.42,0,.18.19.29.45.29.71s-.11.52-.29.71ZM9,37c0,.26-.11.52-.29.71-.05.04-.1.08-.16.12-.05.04-.11.07-.17.09-.06.03-.12.05-.19.06-.06.01-.13.02-.19.02-.26,0-.52-.11-.71-.29-.18-.19-.29-.45-.29-.71s.11-.52.29-.71c.24-.23.58-.33.9-.27.07.01.13.03.19.06.06.02.12.05.17.09.06.04.11.08.16.12.18.19.29.45.29.71ZM45,12h-10c-1.65,0-3,1.35-3,3v33h13c1.65,0,3-1.35,3-3V15c0-1.65-1.35-3-3-3ZM39.08,36.62c.05-.13.12-.23.21-.33.05-.04.1-.09.15-.12.06-.04.12-.07.18-.09.06-.03.12-.05.18-.06.13-.03.27-.03.39,0,.07.01.13.03.19.06.06.02.12.05.17.09.06.03.11.08.16.12.09.1.16.2.21.33.05.12.08.25.08.38s-.03.26-.08.38-.12.23-.21.33c-.05.04-.1.08-.16.12-.05.04-.11.07-.17.09-.06.03-.12.05-.19.06-.06.01-.13.02-.19.02-.07,0-.13-.01-.2-.02-.06-.01-.12-.03-.18-.06-.06-.02-.12-.05-.18-.09-.05-.04-.1-.08-.15-.12-.09-.1-.16-.21-.21-.33s-.08-.25-.08-.38.03-.26.08-.38ZM39,31c0-.13.03-.26.08-.38.05-.13.12-.23.21-.33.05-.04.1-.09.15-.12.06-.04.12-.07.18-.09.06-.03.12-.05.18-.06.13-.03.27-.03.39,0,.07.01.13.03.19.06.06.02.12.05.17.09.06.03.11.08.16.12.09.1.16.2.21.33.05.12.08.25.08.38s-.03.26-.08.38-.12.23-.21.33c-.05.04-.1.08-.16.12-.05.04-.11.07-.17.09-.06.03-.12.05-.19.06-.06.01-.13.02-.19.02-.07,0-.13-.01-.2-.02-.06-.01-.12-.03-.18-.06-.06-.02-.12-.05-.18-.09-.05-.04-.1-.08-.15-.12-.09-.1-.16-.21-.21-.33s-.08-.25-.08-.38ZM40,26c-2.21,0-4-1.79-4-4s1.79-4,4-4,4,1.79,4,4-1.79,4-4,4ZM18,42h12v6h-12v-6ZM18,40h12v-16h-12v16ZM24,28c2.21,0,4,1.79,4,4s-1.79,4-4,4-4-1.79-4-4,1.79-4,4-4ZM42,22c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2ZM22,32c0-1.1.9-2,2-2s2,.9,2,2-.9,2-2,2-2-.9-2-2ZM6,22c0-1.1.9-2,2-2s2,.9,2,2-.9,2-2,2-2-.9-2-2ZM31.778,5.222c-.256,0-.512-.098-.707-.293-3.898-3.898-10.244-3.898-14.143,0-.391.391-1.023.391-1.414,0s-.391-1.023,0-1.414c4.68-4.679,12.291-4.679,16.971,0,.391.391.391,1.023,0,1.414-.195.195-.451.293-.707.293ZM28.95,8.05c-.256,0-.512-.098-.707-.293-1.134-1.133-2.641-1.757-4.243-1.757s-3.109.624-4.243,1.757c-.391.391-1.023.391-1.414,0s-.391-1.023,0-1.414c1.511-1.511,3.521-2.343,5.657-2.343s4.146.832,5.657,2.343c.391.391.391,1.023,0,1.414-.195.195-.451.293-.707.293Z"
						fill={fill}
					/>
				</svg>
			</SVGContainer>
		);
	}

	// [g]
	indicator() {
		return;
	}
}
